import { i18n } from '../../localization';
export const getMenuData = [
  /**
   * Example Menu
   */
  {
    category: true,
    title: 'Dashboards',
    hide: true,
  },
  {
    title: 'Dashboards',
    key: 'dashboards',
    hide: true,
    icon: 'fe fe-home',
    // roles: ['admin'], // set user roles with access to this route
    count: 4,
    children: [
      {
        title: 'Dashboard Alpha',
        key: 'dashboardOld',
        url: '/dashboard/alpha',
      },
      {
        title: 'Dashboard Beta',
        key: 'dashboardBeta',
        url: '/dashboard/beta',
      },
      {
        title: 'Dashboard Gamma',
        key: 'dashboardGamma',
        url: '/dashboard/gamma',
      },
      {
        title: 'Crypto Terminal',
        key: 'dashboardCrypto',
        url: '/dashboard/crypto',
      },
    ],
  },
  {
    category: true,
    title: 'Apps & Pages',
    hide: true,
  },
  {
    title: 'Apps',
    key: 'apps',
    hide: true,
    icon: 'fe fe-database',
    children: [
      {
        title: 'Profile',
        key: 'appsProfile',
        url: '/apps/profile',
      },
      {
        title: 'Calendar',
        key: 'appsCalendar',
        url: '/apps/calendar',
      },
      {
        title: 'Gallery',
        key: 'appsGallery',
        url: '/apps/gallery',
      },
      {
        title: 'Messaging',
        key: 'appsCart',
        url: '/apps/messaging',
      },
      {
        title: 'Mail',
        key: 'appsMail',
        url: '/apps/mail',
      },
    ],
  },
  {
    title: 'Extra Apps',
    key: 'extraApps',
    hide: true,
    icon: 'fe fe-hard-drive',
    children: [
      {
        title: 'Github Explore',
        key: 'extraAppsGithubExplore',
        url: '/apps/github-explore',
      },
      {
        title: 'Github Discuss',
        key: 'extraAppsGithubDiscuss',
        url: '/apps/github-discuss',
      },
      {
        title: 'Digitalocean Droplets',
        key: 'extraAppsDigitaloceanDroplets',
        url: '/apps/digitalocean-droplets',
      },
      {
        title: 'Digitalocean Create',
        key: 'extraAppsDigitaloceanCreate',
        url: '/apps/digitalocean-create',
      },
      {
        title: 'Google Analytics',
        key: 'extraAppsGoogleAnalytis',
        url: '/apps/google-analytics',
      },
      {
        title: 'Wordpress Post',
        key: 'extraAppsWordpressPost',
        url: '/apps/wordpress-post',
      },
      {
        title: 'Wordpress Posts',
        key: 'extraAppsWordpressPosts',
        url: '/apps/wordpress-posts',
      },
      {
        title: 'Wordpress Add',
        key: 'extraAppsWordpressAdd',
        url: '/apps/wordpress-add',
      },
      {
        title: 'Todoist List',
        key: 'extraAppsTodoistList',
        url: '/apps/todoist-list',
      },
      {
        title: 'Jira Dashboard',
        key: 'extraAppsJiraDashboard',
        url: '/apps/jira-dashboard',
      },
      {
        title: 'Jira Agile Board',
        key: 'extraAppsJiraAgileBoard',
        url: '/apps/jira-agile-board',
      },
      {
        title: 'Helpdesk Dashboard',
        key: 'extraAppsHelpdeskDashboard',
        url: '/apps/helpdesk-dashboard',
      },
    ],
  },
  {
    title: 'Ecommerce',
    key: 'ecommerce',
    hide: true,
    icon: 'fe fe-shopping-cart',
    children: [
      {
        title: 'Dashboard',
        key: 'ecommerceDashboard',
        url: '/ecommerce/dashboard',
      },
      {
        title: 'Orders',
        key: 'ecommerceOrders',
        url: '/ecommerce/orders',
      },
      {
        title: 'Propduct Catalog',
        key: 'ecommerceProductCatalog',
        url: '/ecommerce/product-catalog',
      },
      {
        title: 'Product Details',
        key: 'ecommerceProductDetails',
        url: '/ecommerce/product-details',
      },
      {
        title: 'Cart',
        key: 'ecommerceCart',
        url: '/ecommerce/cart',
      },
    ],
  },
  {
    title: 'Auth Pages',
    key: 'auth',
    hide: true,
    icon: 'fe fe-user',
    children: [
      {
        title: 'Login',
        key: 'authLogin',
        url: '/auth/login',
      },
      {
        title: 'Forgot Password',
        key: 'authForgotPassword',
        url: '/auth/forgot-password',
      },
      {
        title: 'Register',
        key: 'authRegister',
        url: '/auth/register',
      },
      {
        title: 'Lockscreen',
        key: 'authLockscreen',
        url: '/auth/lockscreen',
      },
      {
        title: 'Page 404',
        key: 'auth404',
        url: '/auth/404',
      },
      {
        title: 'Page 500',
        key: 'auth500',
        url: '/auth/500',
      },
    ],
  },
  {
    category: true,
    title: 'UI Kits',
    hide: true,
  },
  {
    title: 'Ant Design',
    key: 'antDesign',
    hide: true,
    icon: 'fe fe-bookmark',
    url: '/ui-kits/antd',
  },
  {
    title: 'Bootstrap',
    key: 'bootstrap',
    hide: true,
    icon: 'fe fe-bookmark',
    url: '/ui-kits/bootstrap',
  },
  {
    category: true,
    title: 'Components',
    hide: true,
  },
  {
    title: 'Widgets',
    key: 'widgets',
    hide: true,
    icon: 'fe fe-image',
    count: 47,
    children: [
      {
        title: 'General',
        key: 'widgetsGeneral',
        url: '/widgets/general',
      },
      {
        title: 'Lists',
        key: 'widgetsLists',
        url: '/widgets/lists',
      },
      {
        title: 'Tables',
        key: 'widgetsTables',
        url: '/widgets/tables',
      },
      {
        title: 'Charts',
        key: 'widgetsCharts',
        url: '/widgets/charts',
      },
    ],
  },
  {
    title: 'Cards',
    key: 'cards',
    hide: true,
    icon: 'fe fe-credit-card',
    children: [
      {
        title: 'Basic Cards',
        key: 'cardsBasicCards',
        url: '/cards/basic-cards',
      },
      {
        title: 'Tabbed Cards',
        key: 'cardsTabbedCards',
        url: '/cards/tabbed-cards',
      },
    ],
  },
  {
    title: 'Tables',
    key: 'tables',
    hide: true,
    icon: 'fe fe-grid',
    children: [
      {
        title: 'Ant Design',
        key: 'tablesAntd',
        url: '/tables/antd',
      },
      {
        title: 'Bootstrap',
        key: 'tablesBootstrap',
        url: '/tables/bootstrap',
      },
    ],
  },
  {
    title: 'Charts',
    key: 'charts',
    hide: true,
    icon: 'fe fe-pie-chart',
    children: [
      {
        title: 'Chartist.js',
        key: 'chartsChartistjs',
        url: '/charts/chartistjs',
      },
      {
        title: 'Chart.js',
        key: 'chartsChartjs',
        url: '/charts/chartjs',
      },
      {
        title: 'C3',
        key: 'chartsC3',
        url: '/charts/c3',
      },
    ],
  },
  {
    title: 'Icons',
    key: 'icons',
    hide: true,
    icon: 'fe fe-star',
    children: [
      {
        title: 'Feather Icons',
        key: 'iconsFeatherIcons',
        url: '/icons/feather-icons',
      },
      {
        title: 'Fontawesome',
        key: 'iconsFontawesome',
        url: '/icons/fontawesome',
      },
      {
        title: 'Linearicons Free',
        key: 'iconsLineariconsFree',
        url: '/icons/linearicons-free',
      },
      {
        title: 'Icomoon Free',
        key: 'iconsIcomoonFree',
        url: '/icons/icomoon-free',
      },
    ],
  },
  {
    category: true,
    title: 'Advanced',
    hide: true,
  },
  {
    title: 'Form Examples',
    key: 'formExamples',
    hide: true,
    icon: 'fe fe-menu',
    url: '/advanced/form-examples',
  },
  {
    title: 'Email Templates',
    key: 'emailTemplates',
    hide: true,
    icon: 'fe fe-mail',
    url: '/advanced/email-templates',
  },
  {
    title: 'Pricing Tables',
    key: 'pricingTables',
    hide: true,
    icon: 'fe fe-command',
    url: '/advanced/pricing-tables',
  },
  {
    title: 'Invoice',
    key: 'invoice',
    hide: true,
    icon: 'fe fe-file-text',
    url: '/advanced/invoice',
  },
  {
    title: 'Utilities',
    key: 'utilities',
    hide: true,
    icon: 'fe fe-inbox',
    url: '/advanced/utilities',
  },
  {
    title: 'Grid',
    key: 'grid',
    hide: true,
    icon: 'fe fe-grid',
    url: '/advanced/grid',
  },
  {
    title: 'Typography',
    key: 'typography',
    hide: true,
    icon: 'fe fe-type',
    url: '/advanced/typography',
  },
  {
    title: 'Colors',
    key: 'colors',
    hide: true,
    icon: 'fe fe-feather',
    url: '/advanced/colors',
  },
  {
    title: 'Nested Items',
    key: 'nestedItem1',
    hide: true,
    icon: 'fe fe-layers',
    disabled: true,
    children: [
      {
        title: 'Nested Item 1-1',
        key: 'nestedItem1-1',
        children: [
          {
            title: 'Nested Item 1-1-1',
            key: 'nestedItem1-1-1',
          },
          {
            title: 'Nested Items 1-1-2',
            key: 'nestedItem1-1-2',
            disabled: true,
          },
        ],
      },
      {
        title: 'Nested Items 1-2',
        key: 'nestedItem1-2',
      },
    ],
  },
  {
    title: 'Disabled Item',
    key: 'disabledItem',
    hide: true,
    icon: 'fe fe-slash',
    disabled: true,
  },
  /**
   * Custom Menu
   */
  {
    title: i18n.tc('Manual'),
    key: 'manual',
    icon: 'fa fa-wpforms',
    url: '/manual',
  },
  {
    title: i18n.tc('Dashboards'),
    key: 'dashboard',
    icon: 'fe fe-home',
    url: '/dashboard',
  },
  {
    title: i18n.tc('Project Management'),
    key: 'projectManagement',
    url: '/project-management',
    icon: 'fe fe-file-text',
  },
  {
    title: i18n.tc('Add or Edit Project'),
    key: 'addProject',
    url: '/add-or-edit-project',
    hide: true,
  },
  {
    title: i18n.tc('Report System'),
    key: 'reportSystem',
    icon: 'fe fe-database',
    children: [
      {
        title: i18n.tc('Procurement Report'),
        key: 'procurementReport',
        url: '/report/procurement',
      },
      {
        title: i18n.tc('Contract Management Report'),
        key: 'contractManagement',
        url: '/report/contract-management',
      },
      {
        title: i18n.tc('Disbursement Result Report'),
        key: 'disbursementResult',
        url: '/report/disbursement-result',
      },
    ],
  },
  {
    title: i18n.tc('User Management'),
    key: 'userManagement',
    url: '/user-management',
    icon: 'fe fe-user',
  },
  {
    title: i18n.tc('Division Management'),
    key: 'divisionManagement',
    url: '/division-management',
    icon: 'fe fe-layers',
  },
  {
    title: i18n.tc('Basic Info Management'),
    key: 'basicInfoManagement',
    url: '/auth/404',
    icon: 'fe fe-inbox',
    children: [
      {
        title: i18n.tc('Procurement Type Info'),
        key: 'procurementTypeInfo',
        url: '/basic-info/procurement-type',
      },
      {
        title: i18n.tc('Inspection Type Info'),
        key: 'inspectionTypeInfo',
        url: '/basic-info/inspection-type',
      },
      {
        title: i18n.tc('Plan Info'),
        key: 'plan',
        url: '/basic-info/plan',
      },
      {
        title: i18n.tc('Vendor Info'),
        key: 'vendor',
        url: '/basic-info/vendor',
      },
      // {
      //   title: i18n.tc('Holiday Info'),
      //   key: 'holiday',
      //   url: '/basic-info/holiday',
      // },
    ],
  },
  {
    title: i18n.tc('Role Management'),
    key: 'roleManagement',
    url: '/role-management',
    icon: 'fe fe-grid',
  },
  {
    title: i18n.tc('Config Notify'),
    key: 'configNotify',
    url: '/config-notify',
    icon: 'fe fe-cog',
  },
  // {
  //   title: i18n.tc('Main Menu'),
  //   key: 'mainMenu',
  //   icon: 'fe fe-home',
  //   children: [
  //     /* {
  //       title: i18n.tc('Dashboard'),
  //       key: 'dashboard',
  //       url: '/main-menu/dashboard',
  //     },
  //     {
  //       title: i18n.tc('Reports'),
  //       key: 'reports',
  //       url: '/main-menu/reports',
  //     },
  //     {
  //       title: i18n.tc('Find Users'),
  //       key: 'findUsers',
  //       url: '/main-menu/find-users',
  //     },
  //     {
  //       title: i18n.tc('Find Groups'),
  //       key: 'findGroups',
  //       url: '/main-menu/find-groups',
  //     },
  //     {
  //       title: i18n.tc('Leader Board'),
  //       key: 'leaderBoard',
  //       children: [
  //         {
  //           title: i18n.tc('Province'),
  //           key: 'leaderBoardProvince',
  //           url: '/main-menu/leader-board/province',
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.tc('Random User Names'),
  //       key: 'randomUserNames',
  //       url: '/main-menu/random-user-names',
  //     }, */
  //     {
  //       title: i18n.tc('Dashboards'),
  //       key: 'dashboards',
  //       hide: true,
  //       icon: 'fe fe-home',
  //       url: '/dashboard',
  //     },
  //     {
  //       title: i18n.tc('Project Info Management'),
  //       key: 'projectInfoManagement',
  //       icon: 'fe fe-file-text',
  //       url: 'project-info-management',
  //     },
  //     {
  //       title: i18n.tc('Report System'),
  //       key: 'reportSystem',
  //       hide: true,
  //       icon: 'fe fe-database',
  //       children: [
  //         {
  //           title: 'Page 404',
  //           key: 'report404',
  //           url: '/auth/404',
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.tc('User Management'),
  //       key: 'userManagement',
  //       url: '/main-menu/user-management',
  //       icon: 'fe fe-user',
  //     },
  //     {
  //       title: i18n.tc('Division Management'),
  //       key: 'divisionManagement',
  //       url: '/auth/404',
  //       icon: 'fe fe-layers',
  //     },
  //     {
  //       title: i18n.tc('Basic Info Management'),
  //       key: 'basicInfoManagement',
  //       url: '/auth/404',
  //       icon: 'fe fe-inbox',
  //       children: [
  //         {
  //           title: 'Page 404',
  //           key: 'report404',
  //           url: '/auth/404',
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.tc('Role Management'),
  //       key: 'roleManagement',
  //       url: '/auth/404',
  //       icon: 'fe fe-grid',
  //     },
  //     {
  //       title: i18n.tc('Config Notify'),
  //       key: 'configNotify',
  //       url: '/auth/404',
  //       icon: 'fe fe-cog',
  //     },
  //     /* {
  //       title: i18n.tc('Project Management'),
  //       key: 'projectManagement',
  //       url: '/project-management',
  //     }, */
  //   ],
  // },
];
